import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const {
		blockID,
		buttonText,
		buttonIcon,
		iconPosition,
		enableIcon,
		buttonLinkUrl,
		buttonLinkOpenInNewTab,
		buttonLinkRel,
		buttonLinkTitle,
		buttonAnchorId,
		textAlignment,
	} = attributes;

	const rel = [];
	if ( buttonLinkOpenInNewTab ) {
		rel.push( 'noopener', 'noreferrer' );
	}
	if ( buttonLinkRel ) {
		rel.push( buttonLinkRel );
	}
	const relString = rel.length > 0 ? rel.join( ' ' ) : null;

	const buttonClasses = [ 'alpha-button' ];

	const blockProps = useBlockProps.save( {
		className: `block-${ blockID }`,
	} );

	return (
		<div { ...blockProps }>
			<a
				href={ buttonLinkUrl }
				target={ buttonLinkOpenInNewTab ? '_blank' : null }
				rel={ relString }
				title={ buttonLinkTitle }
				id={ buttonAnchorId }
				className={ buttonClasses.join( ' ' ) }
			>
				<span
					style={ {
						display: 'flex',
						alignItems: 'center',
						justifyContent: textAlignment,
					} }
				>
					{ enableIcon &&
						buttonIcon?.iconName &&
						iconPosition === 'left' && (
							<window.Icon name={ buttonIcon.iconName } />
						) }
					<RichText.Content tagName="span" value={ buttonText } />
					{ enableIcon &&
						buttonIcon?.iconName &&
						iconPosition === 'right' && (
							<Icon name={ buttonIcon.iconName } />
						) }
				</span>
			</a>
		</div>
	);
}
